import { useSelector } from 'react-redux';
import { getUserCondition, normalizeUser } from 'modules/user/utils';
import { usePersistedAsyncAction } from 'modules/keyValueStore/usePersistedAsyncAction';
import { adjustUserForServer, isUser } from './helpers';
import { hcpApi } from './api';

const fetchMatches = async (user, { signal }) => {
  let toFetch = user;
  if (getUserCondition(user)) {
    toFetch = await adjustUserForServer(user);
  }
  return hcpApi.getPublicMatches(toFetch, { signal });
};

const getMatchesParametersId = (params) => JSON.stringify(normalizeUser(params));

export const useCurrentUserPublicMatches = ({ isActive = true } = {}) => {
  const currentUser = useSelector((state) => state.currentUser.data);

  return usePersistedAsyncAction({
    action: fetchMatches,
    parameters: currentUser,
    getParametersId: getMatchesParametersId,
    isActive: isActive && isUser(currentUser),
    storeKey: 'currentUserPublicMatches',
    dataId: 'currentUserPublicMatches',
  });
};
